








































































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import moment from 'moment';
import axios from 'axios';

@Component({
    components: {},
})
export default class CardList extends Vue {

    private loading: boolean = false;

    private list: any[] = [];

    private mounted() {
        axios.get('/api/fake_list', {
            params: {
                count: 8,
            },
        }).then((res: any) => {
            this.list = res.data;
            // console.log(this.list);
        });
    }

}
